var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEnvelopeRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a8l0cm6yoa",
    d: "M21.6 9.742V16.8c0 1.325-1.075 2.4-2.4 2.4H4.8c-1.325 0-2.4-1.075-2.4-2.4V9.742l9.6 4.8 9.6-4.8zM19.2 4.8c1.272 0 2.323.991 2.396 2.26L12 11.859 2.404 7.061C2.477 5.79 3.528 4.8 4.8 4.8z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    fill: "#de384a",
    fillRule: "nonzero",
    xlinkHref: "#a8l0cm6yoa"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEnvelopeRed);
export default __webpack_public_path__ + "static/media/icon-envelope-red.5afa80032c45784ed7d0c5ca5241817b.svg";
export { ForwardRef as ReactComponent };